// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-edit-court-details-container {
  min-height: calc(100vh - 118px);
  background: #f9fafb;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container {
    padding: 1rem;
  }
}
.add-edit-court-details-container .add-edit-court-details-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: court-details-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    padding: 1rem;
    width: 100%;
  }
}
.add-edit-court-details-container .add-edit-court-details-header {
  text-align: center;
  margin-bottom: 0.5rem;
}
.add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
  font-size: 1.6rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 0.5rem 0;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
    font-size: 1.25rem;
  }
}
.add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-subtitle {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0;
}
.add-edit-court-details-container .add-edit-court-details-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.add-edit-court-details-container .form-content {
  padding: 0;
  background: transparent;
  border: none;
  box-shadow: none;
  animation: none;
  width: 100%;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-content {
    padding: 0;
    width: 100%;
  }
}
.add-edit-court-details-container .form-content .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.add-edit-court-details-container .form-content .form-section h3 {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.add-edit-court-details-container .bombay-hc-section-wrapper {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 1.5rem;
  margin-top: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 70%;
  animation: court-details-fade-in 0.3s ease-out;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .bombay-hc-section-wrapper {
    width: 100%;
    padding: 1rem;
  }
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-title {
  font-size: 1.125rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-bottom: 1rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card {
  border: 1px solid #e5e7eb;
  padding: 1rem;
  border-radius: 0.375rem;
  background: #f9fafb;
  transition: all 0.2s ease;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card:hover {
  border-color: #d1d5db;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card-header label {
  margin: 0;
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card-header .remove-btn {
  width: 1.75rem;
  height: 1.75rem;
  background-color: #ef4444;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 1.75rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card-header .remove-btn:hover {
  background-color: #dc2626;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-card-header .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-field-group {
  margin-bottom: 1rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-field-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-field-group .dropdown {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-field-group .dropdown:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-field-group .dropdown:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .text-input,
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .dropdown {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .text-input:focus,
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .dropdown:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .text-input:hover:not(:focus),
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .dropdown:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .text-input::placeholder,
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .dropdown::placeholder {
  color: #9ca3af;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-fields-grid .bombay-hc-field .dropdown {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field {
  margin-bottom: 0.5rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field .text-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field .text-input:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field .text-input:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .bombay-hc-cnr-field .text-input::placeholder {
  color: #9ca3af;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .add-btn {
  padding: 8px 18px;
  background-color: #16a34a;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .add-btn:hover {
  background-color: #15803d;
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .add-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);
}
.add-edit-court-details-container .bombay-hc-section-wrapper .bombay-hc-content .add-btn:active {
  transform: translateY(1px);
}
.add-edit-court-details-container .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-grid {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-grid .court-det-form-group {
  display: flex;
  flex-direction: column;
}
.add-edit-court-details-container .form-grid .court-det-form-group.full-width {
  grid-column: 1/-1;
}
.add-edit-court-details-container .form-grid .court-det-form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.add-edit-court-details-container .form-grid .court-det-form-group label .required {
  color: #ef4444;
  margin-left: 0.25rem;
  font-size: 0.875rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group input,
.add-edit-court-details-container .form-grid .court-det-form-group select,
.add-edit-court-details-container .form-grid .court-det-form-group textarea {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  min-height: 2.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group input:focus,
.add-edit-court-details-container .form-grid .court-det-form-group select:focus,
.add-edit-court-details-container .form-grid .court-det-form-group textarea:focus {
  outline: none;
  border-color: var(--primary-color, #3b82f6);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.add-edit-court-details-container .form-grid .court-det-form-group input:hover:not(:focus),
.add-edit-court-details-container .form-grid .court-det-form-group select:hover:not(:focus),
.add-edit-court-details-container .form-grid .court-det-form-group textarea:hover:not(:focus) {
  border-color: #9ca3af;
}
.add-edit-court-details-container .form-grid .court-det-form-group input::placeholder,
.add-edit-court-details-container .form-grid .court-det-form-group select::placeholder,
.add-edit-court-details-container .form-grid .court-det-form-group textarea::placeholder {
  color: #9ca3af;
}
.add-edit-court-details-container .form-grid .court-det-form-group input:disabled,
.add-edit-court-details-container .form-grid .court-det-form-group select:disabled,
.add-edit-court-details-container .form-grid .court-det-form-group textarea:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.add-edit-court-details-container .form-grid .court-det-form-group select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
  cursor: pointer;
}
.add-edit-court-details-container .form-grid .court-det-form-group select:disabled {
  cursor: not-allowed;
}
.add-edit-court-details-container .form-grid .court-det-form-group select option {
  padding: 0.5rem;
  background: #ffffff;
  color: #374151;
}
.add-edit-court-details-container .form-grid .court-det-form-group .input-with-button {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}
.add-edit-court-details-container .form-grid .court-det-form-group .input-with-button .text-input {
  flex: 1 1;
}
.add-edit-court-details-container .form-grid .court-det-form-group .input-with-button .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .input-with-button .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-grid .court-det-form-group .input-with-button .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
.add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr auto;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs .dropdown {
  width: 100%;
}
.add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-grid .court-det-form-group .high-court-inputs .remove-btn {
    justify-self: center;
  }
}
.add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 0.5rem;
  align-items: center;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
}
.add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs .text-input {
  width: 100%;
}
.add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-grid .court-det-form-group .district-court-inputs .remove-btn {
    justify-self: center;
  }
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options {
  margin-top: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-scrape-type {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-scrape-type .dropdown {
  max-width: 16rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-bar-code-row {
  display: grid;
  grid-template-columns: 6rem 1fr 6rem auto;
  gap: 0.5rem;
  align-items: center;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-bar-code-row .text-input {
  width: 100%;
  min-width: 0;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-bar-code-row .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .dc-bar-code-row .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-grid .court-det-form-group .dc-scrape-options .add-btn {
  align-self: flex-start;
}
.add-edit-court-details-container .form-grid .court-det-form-group > div > .remove-btn {
  width: 2.5rem;
  height: 2.5rem;
  background-color: #dc2626;
  color: white;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 1.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;
  min-width: 2.5rem;
}
.add-edit-court-details-container .form-grid .court-det-form-group > div > .remove-btn:hover {
  background-color: #b91c1c;
}
.add-edit-court-details-container .form-grid .court-det-form-group > div > .remove-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);
}
.add-edit-court-details-container .add-btn {
  padding: 8px 18px;
  background-color: #16a34a;
  color: white;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}
.add-edit-court-details-container .add-btn:hover {
  background-color: #15803d;
}
.add-edit-court-details-container .add-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);
}
.add-edit-court-details-container .add-btn:active {
  transform: translateY(1px);
}
.add-edit-court-details-container .form-actions {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-actions {
    flex-direction: column;
  }
}
.add-edit-court-details-container .form-actions .btn-cancel,
.add-edit-court-details-container .form-actions .btn-submit {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-actions .btn-cancel,
  .add-edit-court-details-container .form-actions .btn-submit {
    width: 100%;
  }
}
.add-edit-court-details-container .form-actions .btn-cancel:disabled,
.add-edit-court-details-container .form-actions .btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.add-edit-court-details-container .form-actions .btn-cancel:hover {
  background-color: #f8f9fa;
}
.add-edit-court-details-container .form-actions .btn-cancel:focus {
  outline: none;
}
.add-edit-court-details-container .form-actions .btn-cancel:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.add-edit-court-details-container .form-actions .btn-submit {
  background-color: var(--primary-color);
  color: white;
}
.add-edit-court-details-container .form-actions .btn-submit:focus {
  outline: none;
}
.add-edit-court-details-container .form-actions .btn-submit:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}

@keyframes court-details-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .add-edit-court-details-container {
    padding: 0.5rem;
  }
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    padding: 0.75rem;
  }
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-title {
    font-size: 1.125rem;
  }
  .add-edit-court-details-container .add-edit-court-details-header .add-edit-court-details-subtitle {
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-grid {
    gap: 0.5rem;
  }
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group label {
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group input,
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group select,
  .add-edit-court-details-container .form-content .form-grid .court-det-form-group textarea {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .add-edit-court-details-container .form-content .form-actions .btn-cancel,
  .add-edit-court-details-container .form-content .form-actions .btn-submit {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .add-edit-court-details-container {
    background: white;
    padding: 0;
  }
  .add-edit-court-details-container .add-edit-court-details-wrapper {
    box-shadow: none;
    border: 1px solid #000;
  }
  .add-edit-court-details-container .form-actions {
    display: none;
  }
}
.add-edit-court-details-container .form-actions-wrapper {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem;
  margin-top: 1.5rem;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  width: 70%;
  animation: court-details-fade-in 0.3s ease-out;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-actions-wrapper {
    width: 100%;
    flex-direction: column;
    padding: 1rem;
  }
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel,
.add-edit-court-details-container .form-actions-wrapper .btn-submit {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
@media (max-width: 768px) {
  .add-edit-court-details-container .form-actions-wrapper .btn-cancel,
  .add-edit-court-details-container .form-actions-wrapper .btn-submit {
    width: 100%;
  }
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel:disabled,
.add-edit-court-details-container .form-actions-wrapper .btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel {
  background-color: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel:hover {
  background-color: #e5e7eb;
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.3);
}
.add-edit-court-details-container .form-actions-wrapper .btn-cancel:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.add-edit-court-details-container .form-actions-wrapper .btn-submit {
  background-color: var(--primary-color, #3b82f6);
  color: white;
}
.add-edit-court-details-container .form-actions-wrapper .btn-submit:hover {
  opacity: 0.9;
}
.add-edit-court-details-container .form-actions-wrapper .btn-submit:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);
}
.add-edit-court-details-container .form-actions-wrapper .btn-submit:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}

.add-edit-court-details-container input:focus-visible,
.add-edit-court-details-container select:focus-visible,
.add-edit-court-details-container textarea:focus-visible,
.add-edit-court-details-container button:focus-visible {
  outline: 2px solid var(--primary-color, #3b82f6);
  outline-offset: 2px;
}`, "",{"version":3,"sources":["webpack://./src/forms/AddEditCourtDetailsForm/AddEditCourtDetailsForm.scss"],"names":[],"mappings":"AACA;EACE,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,aAAA;EACF;AACF;AAEE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,8CAAA;EACA,UAAA;AAAJ;AAEI;EATF;IAUI,aAAA;IACA,WAAA;EACJ;AACF;AAGE;EACE,kBAAA;EACA,qBAAA;AADJ;AAGI;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AADN;AAGM;EANF;IAOI,kBAAA;EAAN;AACF;AAGI;EACE,mBAAA;EACA,cAAA;EACA,SAAA;AADN;AAME;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAJJ;AAQE;EACE,UAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AANJ;AAQI;EARF;IASI,UAAA;IACA,WAAA;EALJ;AACF;AASM;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AAUM;EACE,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AARR;AAaE;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,UAAA;EACA,8CAAA;AAXJ;AAaI;EAVF;IAWI,WAAA;IACA,aAAA;EAVJ;AACF;AAYI;EAEA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAXJ;AAeM;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;AAbR;AAgBM;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AAdR;AAgBQ;EACE,qBAAA;AAdV;AAkBM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAhBR;AAkBQ;EACE,SAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhBV;AAmBQ;EACE,cAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,kBAAA;AAjBV;AAmBU;EACE,yBAAA;AAjBZ;AAoBU;EACE,aAAA;EACA,4CAAA;AAlBZ;AAuBM;EACE,mBAAA;AArBR;AAuBQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AArBV;AAwBQ;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AAtBV;AAwBU;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AAtBZ;AAyBU;EACE,qBAAA;AAvBZ;AA4BM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AA1BR;AA4BQ;EANF;IAOI,0BAAA;IACA,YAAA;EAzBR;AACF;AA4BU;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA1BZ;AA6BU;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA3BZ;AA6BY;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AA1Bd;AA6BY;;EACE,qBAAA;AA1Bd;AA6BY;;EACE,cAAA;AA1Bd;AA8BU;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AA5BZ;AAiCM;EACE,qBAAA;AA/BR;AAiCQ;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA/BV;AAkCQ;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAhCV;AAkCU;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AAhCZ;AAmCU;EACE,qBAAA;AAjCZ;AAoCU;EACE,cAAA;AAlCZ;AAuCM;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AArCR;AAuCQ;EACE,yBAAA;AArCV;AAwCQ;EACE,aAAA;EACA,4CAAA;AAtCV;AAyCQ;EACE,0BAAA;AAvCV;AA8CE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,qBAAA;AA5CJ;AA8CI;EANF;IAOI,0BAAA;IACA,WAAA;EA3CJ;AACF;AA6CI;EACE,aAAA;EACA,sBAAA;AA3CN;AA6CM;EACE,iBAAA;AA3CR;AA8CM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA5CR;AA8CQ;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;AA5CV;AAiDM;;;EAGE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AA/CR;AAiDQ;;;EACE,aAAA;EACA,2CAAA;EACA,6CAAA;AA7CV;AAgDQ;;;EACE,qBAAA;AA5CV;AA+CQ;;;EACE,cAAA;AA3CV;AA8CQ;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AA1CV;AA8CM;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;AA5CR;AA8CQ;EACE,mBAAA;AA5CV;AA+CQ;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AA7CV;AAkDM;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAhDR;AAkDQ;EACE,SAAA;AAhDV;AAmDQ;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AAjDV;AAmDU;EACE,yBAAA;AAjDZ;AAoDU;EACE,aAAA;EACA,4CAAA;AAlDZ;AAwDM;EACE,aAAA;EACA,mCAAA;EACA,WAAA;EACA,mBAAA;AAtDR;AAwDQ;EANF;IAOI,0BAAA;IACA,WAAA;EArDR;AACF;AAuDQ;EACE,WAAA;AArDV;AAwDQ;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AAtDV;AAwDU;EACE,yBAAA;AAtDZ;AAyDU;EACE,aAAA;EACA,4CAAA;AAvDZ;AA0DU;EAxBF;IAyBI,oBAAA;EAvDV;AACF;AA4DM;EACE,aAAA;EACA,uCAAA;EACA,WAAA;EACA,mBAAA;AA1DR;AA4DQ;EANF;IAOI,0BAAA;IACA,WAAA;EAzDR;AACF;AA2DQ;EACE,WAAA;AAzDV;AA4DQ;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AA1DV;AA4DU;EACE,yBAAA;AA1DZ;AA6DU;EACE,aAAA;EACA,4CAAA;AA3DZ;AA8DU;EAxBF;IAyBI,oBAAA;EA3DV;AACF;AAgEM;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AA9DR;AAgEQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;AA9DV;AAgEU;EACE,gBAAA;AA9DZ;AAkEQ;EACE,aAAA;EACA,yCAAA;EACA,WAAA;EACA,mBAAA;AAhEV;AAkEU;EACE,WAAA;EACA,YAAA;AAhEZ;AAmEU;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AAjEZ;AAmEY;EACE,yBAAA;AAjEd;AAsEQ;EACE,sBAAA;AApEV;AAwEM;EACE,aAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sCAAA;EACA,iBAAA;AAtER;AAwEQ;EACE,yBAAA;AAtEV;AAyEQ;EACE,aAAA;EACA,4CAAA;AAvEV;AA8EE;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,sCAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AA5EJ;AA8EI;EACE,yBAAA;AA5EN;AA+EI;EACE,aAAA;EACA,4CAAA;AA7EN;AAgFI;EACE,0BAAA;AA9EN;AAmFE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAjFJ;AAmFI;EAPF;IAQI,sBAAA;EAhFJ;AACF;AAkFI;;EAEE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAhFN;AAkFM;EAfF;;IAgBI,WAAA;EA9EN;AACF;AAgFM;;EACE,mBAAA;EACA,YAAA;AA7ER;AAwFM;EACE,yBAAA;AAtFR;AAyFM;EACE,aAAA;AAvFR;AA2FM;EACE,yBAAA;EACA,cAAA;AAzFR;AA6FI;EACE,sCAAA;EACA,YAAA;AA3FN;AAiGM;EACE,aAAA;AA/FR;AAmGM;EACE,yBAAA;EACA,cAAA;AAjGR;;AAwGA;EACE;IACE,UAAA;IACA,2BAAA;EArGF;EAwGA;IACE,UAAA;IACA,wBAAA;EAtGF;AACF;AA0GA;EAEI;IACE,WAAA;EAzGJ;AACF;AA6GA;EACE;IACE,eAAA;EA3GF;EA6GE;IACE,gBAAA;EA3GJ;EA+GI;IACE,mBAAA;EA7GN;EAgHI;IACE,oBAAA;EA9GN;EAmHI;IACE,WAAA;EAjHN;EAoHQ;IACE,oBAAA;EAlHV;EAqHQ;;;IAGE,iBAAA;IACA,oBAAA;EAnHV;EAyHM;;IAEE,oBAAA;IACA,oBAAA;EAvHR;AACF;AA8HA;EACE;IACE,iBAAA;IACA,UAAA;EA5HF;EA8HE;IACE,gBAAA;IACA,sBAAA;EA5HJ;EA+HE;IACE,aAAA;EA7HJ;AACF;AAmIE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,UAAA;EACA,8CAAA;AAjIJ;AAmII;EAbF;IAcI,WAAA;IACA,sBAAA;IACA,aAAA;EAhIJ;AACF;AAkII;;EAEE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAhIN;AAkIM;EAfF;;IAgBI,WAAA;EA9HN;AACF;AAgIM;;EACE,mBAAA;EACA,YAAA;AA7HR;AAiII;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AA/HN;AAiIM;EACE,yBAAA;AA/HR;AAkIM;EACE,aAAA;EACA,8CAAA;AAhIR;AAmIM;EACE,yBAAA;EACA,cAAA;AAjIR;AAqII;EACE,+CAAA;EACA,YAAA;AAnIN;AAqIM;EACE,YAAA;AAnIR;AAsIM;EACE,aAAA;EACA,6CAAA;AApIR;AAuIM;EACE,yBAAA;EACA,cAAA;AArIR;;AA6IE;;;;EAIE,gDAAA;EACA,mBAAA;AA1IJ","sourcesContent":["// Main Container\n.add-edit-court-details-container {\n  min-height: calc(100vh - 118px);\n  background: #f9fafb;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Form Wrapper - New wrapper structure\n  .add-edit-court-details-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    padding: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    animation: court-details-fade-in 0.3s ease-out;\n    width: 70%;\n\n    @media (max-width: 768px) {\n      padding: 1rem;\n      width: 100%;\n    }\n  }\n\n  // Header styling (moved inside wrapper)\n  .add-edit-court-details-header {\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    .add-edit-court-details-title {\n      font-size: 1.6rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 0.5rem 0;\n\n      @media (max-width: 768px) {\n        font-size: 1.25rem;\n      }\n    }\n\n    .add-edit-court-details-subtitle {\n      font-size: 0.875rem;\n      color: #6b7280;\n      margin: 0;\n    }\n  }\n\n  // Divider styling\n  .add-edit-court-details-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  // Form styling - Updated to work with wrapper\n  .form-content {\n    padding: 0; // Remove padding since it's now in wrapper\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    animation: none;\n    width: 100%;\n\n    @media (max-width: 768px) {\n      padding: 0;\n      width: 100%;\n    }\n\n    // Form sections\n    .form-section {\n      &:last-of-type {\n        border-bottom: none;\n        margin-bottom: 0;\n        padding-bottom: 0;\n      }\n\n      h3 {\n        font-size: 1.125rem;\n        font-weight: 500;\n        color: #374151;\n        margin: 0 0 1rem 0;\n        padding-bottom: 0.5rem;\n        border-bottom: 1px solid #e5e7eb;\n      }\n    }\n  }\n\n  .bombay-hc-section-wrapper {\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    padding: 1.5rem;\n    margin-top: 1.5rem;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 70%;\n    animation: court-details-fade-in 0.3s ease-out;\n\n    @media (max-width: 768px) {\n      width: 100%;\n      padding: 1rem;\n    }\n\n    .bombay-hc-title {\n      //color: var(--primary-color, #1e40af);\n    font-size: 1.125rem;\n    font-weight: 500;\n    color: #374151;\n    margin: 0 0 1rem 0;\n    padding-bottom: 0.5rem;\n    border-bottom: 1px solid #e5e7eb;\n    }\n\n    .bombay-hc-content {\n      .bombay-hc-grid {\n        display: flex;\n        flex-direction: column;\n        gap: 0.75rem;\n        margin-bottom: 1rem;\n      }\n\n      .bombay-hc-card {\n        border: 1px solid #e5e7eb;\n        padding: 1rem;\n        border-radius: 0.375rem;\n        background: #f9fafb;\n        transition: all 0.2s ease;\n\n        &:hover {\n          border-color: #d1d5db;\n        }\n      }\n\n      .bombay-hc-card-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-bottom: 1rem;\n\n        label {\n          margin: 0;\n          font-weight: 500;\n          color: #374151;\n          font-size: 0.875rem;\n        }\n\n        .remove-btn {\n          width: 1.75rem;\n          height: 1.75rem;\n          background-color: #ef4444;\n          color: white;\n          border: none;\n          border-radius: 0.25rem;\n          cursor: pointer;\n          font-size: 0.875rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: background-color 0.2s ease;\n          min-width: 1.75rem;\n\n          &:hover {\n            background-color: #dc2626;\n          }\n\n          &:focus {\n            outline: none;\n            box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\n          }\n        }\n      }\n\n      .bombay-hc-field-group {\n        margin-bottom: 1rem;\n\n        label {\n          display: block;\n          margin-bottom: 0.5rem;\n          font-weight: 500;\n          font-size: 0.875rem;\n          color: #374151;\n        }\n\n        .dropdown {\n          width: 100%;\n          padding: 0.5rem;\n          border: 1px solid #d1d5db;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n          font-family: inherit;\n          color: #374151;\n          background: #ffffff;\n          box-sizing: border-box;\n          min-height: 2.5rem;\n          appearance: none;\n          background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n          background-position: right 0.5rem center;\n          background-repeat: no-repeat;\n          background-size: 1.5rem 1.5rem;\n          padding-right: 2.5rem;\n          cursor: pointer;\n\n          &:focus {\n            outline: none;\n            border-color: var(--primary-color, #3b82f6);\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n\n          &:hover:not(:focus) {\n            border-color: #9ca3af;\n          }\n        }\n      }\n\n      .bombay-hc-fields-grid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 1rem;\n        margin-bottom: 0.5rem;\n\n        @media (max-width: 768px) {\n          grid-template-columns: 1fr;\n          gap: 0.75rem;\n        }\n\n        .bombay-hc-field {\n          label {\n            display: block;\n            margin-bottom: 0.5rem;\n            font-weight: 500;\n            font-size: 0.875rem;\n            color: #374151;\n          }\n\n          .text-input,\n          .dropdown {\n            width: 100%;\n            padding: 0.5rem;\n            border: 1px solid #d1d5db;\n            border-radius: 0.25rem;\n            font-size: 0.875rem;\n            font-family: inherit;\n            color: #374151;\n            background: #ffffff;\n            box-sizing: border-box;\n            min-height: 2.5rem;\n\n            &:focus {\n              outline: none;\n              border-color: var(--primary-color, #3b82f6);\n              box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n            }\n\n            &:hover:not(:focus) {\n              border-color: #9ca3af;\n            }\n\n            &::placeholder {\n              color: #9ca3af;\n            }\n          }\n\n          .dropdown {\n            appearance: none;\n            background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n            background-position: right 0.5rem center;\n            background-repeat: no-repeat;\n            background-size: 1.5rem 1.5rem;\n            padding-right: 2.5rem;\n            cursor: pointer;\n          }\n        }\n      }\n\n      .bombay-hc-cnr-field {\n        margin-bottom: 0.5rem;\n\n        label {\n          display: block;\n          margin-bottom: 0.5rem;\n          font-weight: 500;\n          font-size: 0.875rem;\n          color: #374151;\n        }\n\n        .text-input {\n          width: 100%;\n          padding: 0.5rem;\n          border: 1px solid #d1d5db;\n          border-radius: 0.25rem;\n          font-size: 0.875rem;\n          font-family: inherit;\n          color: #374151;\n          background: #ffffff;\n          box-sizing: border-box;\n          min-height: 2.5rem;\n\n          &:focus {\n            outline: none;\n            border-color: var(--primary-color, #3b82f6);\n            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n          }\n\n          &:hover:not(:focus) {\n            border-color: #9ca3af;\n          }\n\n          &::placeholder {\n            color: #9ca3af;\n          }\n        }\n      }\n\n      .add-btn {\n        padding: 8px 18px;\n        background-color: #16a34a;\n        color: white;\n        border: none;\n        border-radius: 0.375rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        cursor: pointer;\n        transition: background-color 0.2s ease;\n        display: inline-flex;\n        align-items: center;\n        gap: 0.5rem;\n\n        &:hover {\n          background-color: #15803d;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n        }\n\n        &:active {\n          transform: translateY(1px);\n        }\n      }\n    }\n  }\n\n  // Form grid for court details\n  .form-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n      gap: 0.5rem;\n    }\n\n    .court-det-form-group {\n      display: flex;\n      flex-direction: column;\n\n      &.full-width {\n        grid-column: 1 / -1;\n      }\n\n      label {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        color: #374151;\n\n        .required {\n          color: #ef4444;\n          margin-left: 0.25rem;\n          font-size: 0.875rem;\n        }\n      }\n\n      // Input styling to match SACompanyForm\n      input,\n      select,\n      textarea {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        color: #374151;\n        background: #ffffff;\n        box-sizing: border-box;\n        min-height: 2.5rem;\n\n        &:focus {\n          outline: none;\n          border-color: var(--primary-color, #3b82f6);\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &:hover:not(:focus) {\n          border-color: #9ca3af;\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n        &:disabled {\n          background-color: #f9fafb;\n          color: #6b7280;\n          cursor: not-allowed;\n        }\n      }\n\n      select {\n        appearance: none;\n        background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n        background-position: right 0.5rem center;\n        background-repeat: no-repeat;\n        background-size: 1.5rem 1.5rem;\n        padding-right: 2.5rem;\n        cursor: pointer;\n\n        &:disabled {\n          cursor: not-allowed;\n        }\n\n        option {\n          padding: 0.5rem;\n          background: #ffffff;\n          color: #374151;\n        }\n      }\n\n      // Special styling for input groups with buttons\n      .input-with-button {\n        display: flex;\n        gap: 0.5rem;\n        align-items: center;\n\n        .text-input {\n          flex: 1;\n        }\n\n        .remove-btn {\n          width: 2.5rem;\n          height: 2.5rem;\n          background-color: #dc2626;\n          color: white;\n          border: none;\n          border-radius: 0.25rem;\n          cursor: pointer;\n          font-size: 1.125rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: background-color 0.2s ease;\n          min-width: 2.5rem;\n\n          &:hover {\n            background-color: #b91c1c;\n          }\n\n          &:focus {\n            outline: none;\n            box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n          }\n        }\n      }\n\n      // High Court inputs styling\n      .high-court-inputs {\n        display: grid;\n        grid-template-columns: 1fr 1fr auto;\n        gap: 0.5rem;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          grid-template-columns: 1fr;\n          gap: 0.5rem;\n        }\n\n        .dropdown {\n          width: 100%;\n        }\n\n        .remove-btn {\n          width: 2.5rem;\n          height: 2.5rem;\n          background-color: #dc2626;\n          color: white;\n          border: none;\n          border-radius: 0.25rem;\n          cursor: pointer;\n          font-size: 1.125rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: background-color 0.2s ease;\n          min-width: 2.5rem;\n\n          &:hover {\n            background-color: #b91c1c;\n          }\n\n          &:focus {\n            outline: none;\n            box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n          }\n\n          @media (max-width: 768px) {\n            justify-self: center;\n          }\n        }\n      }\n\n      // District Court inputs styling\n      .district-court-inputs {\n        display: grid;\n        grid-template-columns: 1fr 1fr 1fr auto;\n        gap: 0.5rem;\n        align-items: center;\n\n        @media (max-width: 768px) {\n          grid-template-columns: 1fr;\n          gap: 0.5rem;\n        }\n\n        .text-input {\n          width: 100%;\n        }\n\n        .remove-btn {\n          width: 2.5rem;\n          height: 2.5rem;\n          background-color: #dc2626;\n          color: white;\n          border: none;\n          border-radius: 0.25rem;\n          cursor: pointer;\n          font-size: 1.125rem;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          transition: background-color 0.2s ease;\n          min-width: 2.5rem;\n\n          &:hover {\n            background-color: #b91c1c;\n          }\n\n          &:focus {\n            outline: none;\n            box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n          }\n\n          @media (max-width: 768px) {\n            justify-self: center;\n          }\n        }\n      }\n\n      // District Court \"scrape by\" + bar codes\n      .dc-scrape-options {\n        margin-top: 0.5rem;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n\n        .dc-scrape-type {\n          display: flex;\n          align-items: center;\n          gap: 0.5rem;\n          font-size: 0.875rem;\n\n          .dropdown {\n            max-width: 16rem;\n          }\n        }\n\n        .dc-bar-code-row {\n          display: grid;\n          grid-template-columns: 6rem 1fr 6rem auto;\n          gap: 0.5rem;\n          align-items: center;\n\n          .text-input {\n            width: 100%;\n            min-width: 0;\n          }\n\n          .remove-btn {\n            width: 2.5rem;\n            height: 2.5rem;\n            background-color: #dc2626;\n            color: white;\n            border: none;\n            border-radius: 0.25rem;\n            cursor: pointer;\n            font-size: 1.125rem;\n\n            &:hover {\n              background-color: #b91c1c;\n            }\n          }\n        }\n\n        .add-btn {\n          align-self: flex-start;\n        }\n      }\n\n      > div > .remove-btn {\n        width: 2.5rem;\n        height: 2.5rem;\n        background-color: #dc2626;\n        color: white;\n        border: none;\n        border-radius: 0.25rem;\n        cursor: pointer;\n        font-size: 1.125rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        transition: background-color 0.2s ease;\n        min-width: 2.5rem;\n\n        &:hover {\n          background-color: #b91c1c;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n        }\n      }\n    }\n  }\n\n  // Add button styling\n  .add-btn {\n    padding: 8px 18px;\n    background-color: #16a34a;\n    color: white;\n    border: none;\n    border-radius: 0.375rem;\n    font-weight: 500;\n    font-size: 0.875rem;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    display: inline-flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1.5rem;\n\n    &:hover {\n      background-color: #15803d;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n    }\n\n    &:active {\n      transform: translateY(1px);\n    }\n  }\n\n  // Form actions\n  .form-actions {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .btn-cancel,\n    .btn-submit {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n    }\n\n    .btn-cancel {\n      // background: #dc3545;\n      // color: white;\n\n      // &:hover:not(:disabled) {\n      //   background-color: #b91c1c;\n      // }\n      &:hover {\n        background-color: #f8f9fa;\n      }\n\n      &:focus {\n        outline: none;\n        //box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n      }\n    }\n\n    .btn-submit {\n      background-color: var(--primary-color);\n      color: white;\n\n      // &:hover:not(:disabled) {\n      //   background-color: #15803d;\n      // }\n\n      &:focus {\n        outline: none;\n        //box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes court-details-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .add-edit-court-details-container {\n    .add-edit-court-details-wrapper {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .add-edit-court-details-container {\n    padding: 0.5rem;\n\n    .add-edit-court-details-wrapper {\n      padding: 0.75rem;\n    }\n\n    .add-edit-court-details-header {\n      .add-edit-court-details-title {\n        font-size: 1.125rem;\n      }\n\n      .add-edit-court-details-subtitle {\n        font-size: 0.8125rem;\n      }\n    }\n\n    .form-content {\n      .form-grid {\n        gap: 0.5rem;\n\n        .court-det-form-group {\n          label {\n            font-size: 0.8125rem;\n          }\n\n          input,\n          select,\n          textarea {\n            padding: 0.375rem;\n            font-size: 0.8125rem;\n          }\n        }\n      }\n\n      .form-actions {\n        .btn-cancel,\n        .btn-submit {\n          padding: 0.5rem 1rem;\n          font-size: 0.8125rem;\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .add-edit-court-details-container {\n    background: white;\n    padding: 0;\n\n    .add-edit-court-details-wrapper {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .form-actions {\n      display: none;\n    }\n  }\n}\n\n// Form Actions - Separate Section at Bottom\n.add-edit-court-details-container {\n  .form-actions-wrapper {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 1.5rem;\n    margin-top: 1.5rem;\n    background: #ffffff;\n    border: 1px solid #e5e7eb;\n    border-radius: 6px;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    width: 70%;\n    animation: court-details-fade-in 0.3s ease-out;\n\n    @media (max-width: 768px) {\n      width: 100%;\n      flex-direction: column;\n      padding: 1rem;\n    }\n\n    .btn-cancel,\n    .btn-submit {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 0.5rem;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &:disabled {\n        cursor: not-allowed;\n        opacity: 0.6;\n      }\n    }\n\n    .btn-cancel {\n      background-color: #f3f4f6;\n      color: #374151;\n      border: 1px solid #d1d5db;\n\n      &:hover {\n        background-color: #e5e7eb;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.3);\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n      }\n    }\n\n    .btn-submit {\n      background-color: var(--primary-color, #3b82f6);\n      color: white;\n\n      &:hover {\n        opacity: 0.9;\n      }\n\n      &:focus {\n        outline: none;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.3);\n      }\n\n      &:disabled {\n        background-color: #d1d5db;\n        color: #9ca3af;\n      }\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.add-edit-court-details-container {\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid var(--primary-color, #3b82f6);\n    outline-offset: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
